import { BaseChannel } from "@/api/ws/channels/BaseChannel";

export class ChatPublicChannel extends BaseChannel {
  name = "borrower_platform.ai_agent_sessions";
}
